import mod from "-!./App.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./App.js?vue&type=script&lang=js&external"